<template>
  <tr
    class="data-table__row"
    :class="{ 'data-table__row--draggable': manualOrder }"
  >
    <td @click.stop>
      <v-checkbox
        @change="$emit('select', $event)"
        :value="isSelected"
      ></v-checkbox>
    </td>

    <td v-for="(td, idx) in headers" :key="idx">
      <div
        v-if="manualOrder && td.type == 'order'"
        class="submissions-row__order-actions"
      >
        <v-btn icon @click.stop="$emit('moveUp')">
          <v-icon>$arrow_up</v-icon>
        </v-btn>
        <v-btn icon @click.stop="$emit('moveDown')">
          <v-icon>$arrow_down</v-icon>
        </v-btn>
      </div>
      <div v-if="td.type == 'text'">{{ value[td.value] }}</div>
      <div v-else-if="td.type == 'created_at'">
        {{
          value.created_at
            | moment(
              "timezone",
              currentUser.active_project.timezone,
              "MM/DD/YY h:mm A zz"
            )
        }}
      </div>
      <div v-else-if="td.type == 'status'">
        <div class="status status--published" v-if="value.published">
          Published
        </div>
        <div class="status status--not-published" v-else>Not published</div>
      </div>
      <div v-else-if="td.type == 'Select'">
        {{ getSelectLabel(td) }}
      </div>
      <div v-else-if="td.generic">
        <div v-if="value.indexed_formatted_data[td.uuid]">
          <div
            v-if="
              td.type == 'MediaField' &&
              value.indexed_formatted_data[td.uuid].value
            "
          >
            <a
              target="_blank"
              :href="value.indexed_formatted_data[td.uuid].value.url"
            >
              <span>{{
                getNameFromUrl(value.indexed_formatted_data[td.uuid].value.url)
              }}</span>
            </a>
          </div>
          <div v-else>
            <span
              v-if="
                value.indexed_formatted_data[td.uuid] &&
                value.indexed_formatted_data[td.uuid].value
              "
            >
              {{ value.indexed_formatted_data[td.uuid].value }}
            </span>
            <span v-else>N/A</span>
          </div>
        </div>
        <span v-else>N/A</span>
      </div>
      <div v-else-if="td.type == 'actions'">
        <Actions
          hide-duplicate
          :path="`submission-forms/${submissionForm.id}/submissions/${value.id}`"
          @destroy="$emit('destroy')"
        >
        </Actions>
      </div>
    </td>
  </tr>
</template>

<script>
export default {
  props: {
    value: Object,
    headers: Array,
    manualOrder: Boolean,
    isSelected: Boolean,
    submissionForm: Object,
  },
  methods: {
    getSelectLabel(td) {
      try {
        return this.submissionForm.submission_form
          .find((t) => t.uuid == td.uuid)
          .options.find(
            (t) => t.uuid == this.value.indexed_formatted_data[td.uuid].value
          ).title;
      } catch {
        return this.value.indexed_formatted_data[td.uuid] &&
          this.value.indexed_formatted_data[td.uuid].value
          ? this.value.indexed_formatted_data[td.uuid].value
          : "N/A";
      }
    },
    getNameFromUrl(url) {
      const t = (url || "").split("/");
      return t[t.length - 1];
    },
  },
};
</script>

<style scoped lang="scss">
.submissions-row {
  &__order-actions {
    display: flex;
  }
}

.status {
  padding: 3px 10px;
  border-radius: 3px;
  white-space: nowrap;
  &--published {
    background: #099b09c4;
    color: white;
  }
  &--not-published {
    background: gray;
    color: white;
  }
}
</style>
